<template>
  <div class="layer-controls-root">
    <div
      v-for="(problem, index) in problems"
      :id="`layer-control-` + index"
      class="an-toolbar"
      :class="{ active: state[index], ['btn_' + index]: true }"
      :style="getCurrentProblemStyle(problem)"
      :title="problem.title"
      :key="index"
      :ref="`control-${index}`"
      @click="onClick(index, problem.id)"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { DISCARD_FILTERS, FILTER_BY_PROBLEM } from '@/store/actions.type';

export default {
  name: 'LayerControls',
  data() {
    return {
      all: '',
      /** `public/i/map-buttons-v3.png` */
      mapButtonsSprite: `${import.meta.env.BASE_URL}i/map-buttons-v3.png`,
    };
  },
  computed: {
    ...mapGetters(['problems', 'isMobile']),
    state() {
      return this.problems.map((item) => {
        return true;
      });
    },
  },
  mounted() {
    this.controls = [];
    for (var i = 0; i < this.problems.length; i++) {
      this.controls.push(document.getElementById(`layer-control-${i}`));
    }
  },
  methods: {
    getCurrentProblemStyle(problem) {
      const side = this.isMobile ? '47px' : '94px';
      const style = {
        'background-color': problem.color,
        'background-image': `url(${this.mapButtonsSprite})`,
        cursor: 'pointer',
        'margin-bottom': '20px',
        width: side,
        height: side,
        display: 'inline-block',
        'background-repeat': 'no-repeat',
        'background-size': this.isMobile ? '376px 188px' : '752px 376px',
      };

      return style;
    },
    toggleActive(index, state) {
      let control = this.$refs['control-' + index][0];
      control.classList.toggle('active', state);
    },
    onClick(index, id) {
      this.state[index] = !this.state[index];
      this.toggleActive(index, this.state[index]);

      if (index === 7) {
        for (let i = 0; i < 7; i++) {
          this.state[i] = this.state[index];
          this.toggleActive(i, this.state[index]);
        }
        this.$store.commit(DISCARD_FILTERS, this.state[index]);
      } else {
        let all = this.state.slice(0, 7).reduce(function (res, item) {
          res += 1 * item;
          return res;
        }, '');

        let state = all === '0000000' ? false : all === '1111111' ? true : null;

        if (typeof state === 'boolean') {
          this.state[7] = state;
          this.toggleActive(7, state);
        }

        this.$store.commit(FILTER_BY_PROBLEM, {
          visibility: this.state[index],
          problemId: id,
        });
      }
    },
  },
};
</script>
